import { WP_REST_API_Post } from 'wp-types/index'
import { CategoryType } from '../../components/Category'

export const getCategoryAndTags = (
    post: WP_REST_API_Post,
): { category: CategoryType; tags: string[] | undefined } => {
    const terms = post._embedded?.['wp:term']
    const categories = Object.values(CategoryType)
    let categoryIndex = 0
    // @ts-ignore
    const category = terms.find((term: any) =>
        term.find((field: any, index: number) => {
            if (field.taxonomy === 'category' && categories.includes(field.slug)) {
                categoryIndex = index
                return true
            }
            return false
        }),
    )?.[categoryIndex].slug
    const tags = getTags(post)
    return { category, tags }
}

export const getTags = (post: WP_REST_API_Post): string[] | undefined => {
    return post._embedded?.['wp:term']
        ?.flatMap((term) => {
            // @ts-ignore
            const tagNames = term
                .filter((field: { taxonomy: string }) => field.taxonomy === 'post_tag')
                .map((field: { name: string }) => field.name)
            return tagNames.length > 0 ? tagNames : undefined
        })
        .filter((tag) => tag)
}
